import { EnvironmentLoader } from './environment-loader.util';

export function createProxy<T extends object>(target: T, path = ''): T {
    return new Proxy(target, {
        get(_obj: T, prop: string) {
            const fullPath = path ? `${path}.${prop}` : prop;

            const value = fullPath.split('.').reduce((a, c) => a[c], EnvironmentLoader.environment);

            if (value !== null && typeof value === 'object') {
                return createProxy(value, String(fullPath));
            }

            return value;
        },
    });
}
